// Shared constants for clinical logs
export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const MED_FORMS = [
  { id: 'tablet', label: 'Tablet/Capsule' },
  { id: 'liquid', label: 'Liquid' },
  { id: 'powder', label: 'Powder' },
  { id: 'suppository', label: 'Suppository' },
  { id: 'transdermal_patch', label: 'Transdermal Patch' },
  { id: 'nasal_spray', label: 'Nasal Spray' },
  { id: 'inhaler', label: 'Inhaler' },
  { id: 'ear_drops', label: 'Ear Drops' },
  { id: 'eye_drops', label: 'Eye Drops' },
  { id: 'injection', label: 'Injection' },
];

export const INJECTION_ROUTES = [
  { id: 'intravenous', label: 'Intravenous (IV)' },
  { id: 'intramuscular', label: 'Intramuscular (IM)' },
  { id: 'intra_articular', label: 'Intra-articular' },
  { id: 'subcutaneous', label: 'Subcutaneous (SC)' },
];

export const FREQUENCIES = [
  { id: 'OD', label: 'Once Daily (OD - 24hrly)' },
  { id: 'BD', label: 'Twice Daily (BD - 12hrly)' },
  { id: 'TDS', label: 'Three Times (TDS - 8hrly)' },
  { id: 'QDS', label: 'Four Times (QDS - 6hrly)' },
  { id: 'PRN', label: 'As Required (PRN)' },
];

export const WOUND_TYPES = [
  'pressure_ulcer', 'surgical', 'laceration', 'burn', 'diabetic_ulcer', 'skin_tear', 'other'
];
